import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	Button,
	Box,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";

const SaveWithoutPreviewConfirmationModal = ({
	open,
	onClose,
	onConfirm,
	resources,
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				<Box display="flex" alignItems="center">
					<Warning style={{ marginRight: 8, color: "#f9a825" }} />
					<Typography variant="h6">
						{resources["PreviewWarningTitle"]}
					</Typography>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Typography>{resources["PreviewWarningMessage"]}</Typography>
			</DialogContent>
			<DialogActions style={{paddingBottom: '16px', paddingRight: '24px'}}>
				<Button onClick={onClose} color="primary" id="view-preview-button">
					{resources["ViewPreview"]}
				</Button>
				<Button onClick={onConfirm} color="primary" variant="contained" id="continue-without-preview-button">
					{resources["ContinueWithoutPreview"]}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SaveWithoutPreviewConfirmationModal;
